import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL, get } from "../api";
import { Item } from "../@types";

function useOrderItemDetails(
  itemId: string,
  options?: QueryObserverOptions<APIResponse<Item>, APIError>
) {
  const {
    data: orderItem,
    isError,
    error,
    isLoading,
  } = useQuery<APIResponse<Item>, APIError>(
    "order-item-details-" + itemId,
    () =>
      get(API_URL + "/commerce/orders/items/" + itemId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    orderItem,
    isError,
    error,
    isLoading,
  };
}

export default useOrderItemDetails;
